import React from 'react';
import { Route } from 'react-router-dom';
import { DocumentPage } from './DocumentPage';

export const routes = [<Route key="0" path="/document" component={DocumentPage} />];

export const navigation = { name: 'document', link: '/document', parent: 'BoardMembers', match: '/document/:tab' };
